import React, { useRef } from "react";

import "./lead-gen-product-row.css";
import {
	FONT_SIZE,
	PaddedContainer,
	SPACING,
	Text,
	genClassName,
} from "@disco/disco_core";
import LeadGenBottomRowElement from "./LeadGenBottomRowElement";
import accessibilityProvider from "../../utils/accessibilityProvider";
import useElementInView from "../../hooks/useElementInView";
import { generateProductRowData } from ".";
import useData from "../../hooks/useData";
import useExperience from "../../hooks/useExperience";
import useCustomization, {
	CUSTOMIZATION_DETAIL,
	CUSTOMIZATION_TYPE,
} from "../../hooks/useCustomization";
import useLeadGenV0Config from "../../hooks/useLeadGenV0Config";

const LeadGenProductRow = ({
	className = "",
	parentHPadding,
	showHeading = true,
	...rest
}) => {
	const data = useData();
	const products = generateProductRowData({ data });
	const { isLargeWidget } = useLeadGenV0Config();
	const parentContainerRef = useRef();

	const { applyCustomizationOrFallback } = useCustomization();

	const heading = applyCustomizationOrFallback(
		CUSTOMIZATION_DETAIL[CUSTOMIZATION_TYPE.CHECKOUT]
			.WIDGET_BOTTOM_SLOT_HEADING,
		"Trending brands we think you'll love"
	);

	const { isPartiallyInView } = useElementInView({
		elementRef: parentContainerRef,
	});

	return (
		<PaddedContainer
			className={genClassName({
				base: "lead-gen-product-row",
				additional: className,
			})}
			ref={parentContainerRef}
			{...rest}
		>
			{showHeading && (
				<Text
					size={
						isLargeWidget ? FONT_SIZE.SUB_TITLE : FONT_SIZE.LG_BODY
					}
					thick
					hPadding={parentHPadding}
					{...accessibilityProvider({
						name: heading,
						role: "heading",
						level: 2,
					})}
				>
					{heading}
				</Text>
			)}
			<PaddedContainer
				marginTop={isLargeWidget ? SPACING.SMALL : SPACING.TINY}
				flexContent
				className="lead-gen-product-row-products"
				style={{
					"--side-spacing": `${parentHPadding}px`,
				}}
			>
				{products.map(({ brand, ...product }, idx) => (
					<LeadGenBottomRowElement
						product={product}
						idx={idx}
						brand={brand}
						parentContainerRef={parentContainerRef}
						isParentInView={isPartiallyInView}
						key={idx}
					/>
				))}
			</PaddedContainer>
		</PaddedContainer>
	);
};

export default LeadGenProductRow;
